import React from "react";

export default function Six({ fill, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <path d="M250.85,223.31H53.06a12,12,0,0,1-12-12V13.51a12,12,0,0,1,12-12H250.92a12,12,0,0,1,12,12V211.38A12.13,12.13,0,0,1,250.85,223.31ZM53.06,4a9.55,9.55,0,0,0-9.54,9.53V211.3a9.55,9.55,0,0,0,9.54,9.54H250.85a9.64,9.64,0,0,0,9.61-9.47V13.51A9.55,9.55,0,0,0,250.92,4Z" />
      {children}
    </svg>
  );
}
